import { render, staticRenderFns } from "./compareSummary.vue?vue&type=template&id=b1581c98&scoped=true&"
import script from "./compareSummary.vue?vue&type=script&lang=js&"
export * from "./compareSummary.vue?vue&type=script&lang=js&"
import style0 from "./compareSummary.vue?vue&type=style&index=0&id=b1581c98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1581c98",
  null
  
)

export default component.exports